import React, { useState } from 'react';
import {
  FaInfoCircle,
  FaShieldAlt,
  FaEnvelope,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

import { ContactModal } from '../common';

const Footer: React.FC = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  // 緑色のカラーコード
  const activeColor = 'text-green-600'; // 緑色
  const inactiveColor = 'text-amber-100';

  return (
    <footer className="red-earth-bg p-4 border-t border-amber-800">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start">
          {/* 左側：サイトリンク */}
          <div className="flex justify-center md:justify-start flex-wrap mb-4 md:mb-0">
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `flex items-center text-sm ${isActive ? activeColor : inactiveColor} hover:text-green-600 mx-1 mb-2`
              }
            >
              <FaInfoCircle className="mr-1" size={12} />
              サイトについて
            </NavLink>
            <NavLink
              to="/privacy"
              className={({ isActive }) =>
                `flex items-center text-sm ${isActive ? activeColor : inactiveColor} hover:text-green-600 mx-1 mb-2`
              }
            >
              <FaShieldAlt className="mr-1" size={12} />
              プライバシーポリシー
            </NavLink>
            <NavLink
              to="/terms"
              className={({ isActive }) =>
                `flex items-center text-sm ${isActive ? activeColor : inactiveColor} hover:text-green-600 mx-1 mb-2`
              }
            >
              <FaShieldAlt className="mr-1" size={12} />
              利用規約
            </NavLink>
            {/* サイトマップは一旦コメントアウト
            <NavLink 
              to="/sitemap" 
              className={({ isActive }) => 
                `flex items-center text-sm ${isActive ? activeColor : inactiveColor} hover:text-green-600 mx-1 mb-2`
              }
            >
              <FaSitemap className="mr-1" size={12} />サイトマップ
            </NavLink>
            */}
            <button
              onClick={() => setIsContactModalOpen(true)}
              className="flex items-center text-sm text-amber-100 hover:text-green-600 mx-1 mb-2"
            >
              <FaEnvelope className="mr-1" size={12} />
              お問い合わせ
            </button>
          </div>

          {/* 右側：SNSアイコンとコピーライト */}
          <div className="flex flex-col items-center md:items-end">
            <div className="flex mb-2">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-100 hover:text-green-600 mx-2"
              >
                <FaFacebook size={24} />
              </a>
              <a
                href="https://twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-100 hover:text-green-600 mx-2"
              >
                <FaTwitter size={24} />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-100 hover:text-green-600 mx-2"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-100 hover:text-green-600 mx-2"
              >
                <FaYoutube size={24} />
              </a>
            </div>
            <div className="text-amber-100 text-sm whitespace-nowrap">
              &copy; 2025 古代生物図鑑 Siska. All rights reserved.
            </div>
          </div>
        </div>
      </div>

      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
    </footer>
  );
};

export default Footer;
